import { useQuery } from "@tanstack/react-query";

import keys from "Consultants/Api/keys";
import { getConsultants } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const useConsultantsQuery = () =>
	useQuery({
		queryKey: keys.consultants(),
		queryFn: processResponse(() => getConsultants()),
		staleTime: 5 * 60 * 1000,
	});
